var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgFileCardFlip = function SvgFileCardFlip(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 166,
    viewBox: "0 0 23 166",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "AscFileCard_flip__YfJKh",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0L23 0V142.645L0 165.644V165.652L0 165.645L0 165.644V0",
    fill: "#ECEBFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23 142.664L0 165.664V152.664C0 147.141 5.10337 142.664 10.6262 142.664H23Z",
    fill: "#4239FB"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgFileCardFlip);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjMiIGhlaWdodD0iMTY2IiB2aWV3Qm94PSIwIDAgMjMgMTY2IiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciCiAgICBjbGFzcz0iQXNjRmlsZUNhcmRfZmxpcF9fWWZKS2giPgogICAgPHBhdGggZD0iTTAgMEwyMyAwVjE0Mi42NDVMMCAxNjUuNjQ0VjE2NS42NTJMMCAxNjUuNjQ1TDAgMTY1LjY0NFYwIiBmaWxsPSIjRUNFQkZGIgogICAgPjwvcGF0aD4KICAgIDxwYXRoIGQ9Ik0yMyAxNDIuNjY0TDAgMTY1LjY2NFYxNTIuNjY0QzAgMTQ3LjE0MSA1LjEwMzM3IDE0Mi42NjQgMTAuNjI2MiAxNDIuNjY0SDIzWiIKICAgICAgICBmaWxsPSIjNDIzOUZCIj48L3BhdGg+Cjwvc3ZnPg==";